// extracted by mini-css-extract-plugin
export default {"carousel":"team-carousel-section_carousel__R8Oye","grid":"team-carousel-section_grid__J4M7p"};